export default [
    {
        path: '/couponmanage', // 优惠券管理
        component: resolve => require(['@/pages/activity/coupon/couponManage'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/canselectcoupon', // 可以选择的优惠券
        component: resolve => require(['@/pages/activity/coupon/canSelectCoupon'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/opencoupon', // 拆开优惠券红包
        component: resolve => require(['@/pages/activity/coupon/openCoupon'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/getcoupon', // 领取优惠券
        component: resolve => require(['@/pages/activity/coupon/getCoupon'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/couponlogin', // 在非微信环境下领取优惠券登录
        component: resolve => require(['@/pages/activity/coupon/couponLogin'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/couponcode', // 优惠券兑换码
        component: resolve => require(['@/pages/activity/coupon/couponCode'], resolve),
        meta: { title: "长龙航空", requiresAuth: true}
    },
    // {
    //     path: '/couponmanage2', // 优惠券管理
    //     component: resolve => require(['@/pages/activity/coupon/couponManage2'], resolve),
    //     meta: { title: "长龙航空" }
    // },
]



// WEBPACK FOOTER //
// ./src/router/modules/coupon.js